export const filters_store = {
    protocol_id: {
        type:'list',
        list: [],
        value: null,
        placeholder: '',
        item_text:"name",
        item_value:"id",
        // style: 'max-width:200px'
    },
    'adverse_event.cin': {
        type:'text',
        replace: "%VALUE%",
        value: null
    },
        'site.code': {
        type:'text',
        replace: "%VALUE%",
        placeholder: '',
        style: 'max-width:60px',
        value: null
    },
        "adverse_event.patient_id": {
        type:'text',
        replace: "%VALUE%",
        placeholder: '',
        style: 'max-width:60px',
        value: null
    },
    'adverse_event.ae_verbatim_reported': {
        type:'text',
        replace: "%VALUE%",
        value: null
    },
    status: {
        type:'list',
        value: "Open",
        list: ["Open", "Closed", "Reply"],
        placeholder: '',
        style: 'max-width:90px',
    },

}